import {
  FC, ReactNode,
} from 'react';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useTranslation } from 'react-i18next';

type TBaseMobileStepper = {
  children: ReactNode
  activeStep: number
  handleNext?: () => void
  handleBack?: () => void
  isNextDisabled: boolean
  steps: Array<string>
};

const BaseMobileStepper: FC<TBaseMobileStepper> = ({
  children,
  activeStep,
  handleNext = () => {},
  handleBack = () => {},
  isNextDisabled,
  steps,
}) => {
  const theme = useTheme();
  const { t } = useTranslation(['payroll', 'common']);

  return (
    <>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 50,
          bgcolor: 'background.default',
        }}
      >
        <Typography fontWeight={600}>{t(`${steps[activeStep]}`)}</Typography>
      </Paper>
      <MobileStepper
        variant="progress"
        steps={3}
        position="static"
        activeStep={activeStep}
        sx={{ maxWidth: 400, flexGrow: 1 }}
        nextButton={(
          <Button onClick={handleNext} size="small" disabled={isNextDisabled || activeStep === steps.length - 1}>
            {t('next', { ns: 'common' })}
            <KeyboardArrowRight />
          </Button>
      )}
        backButton={(
          <Button onClick={handleBack} size="small" disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            {t('back', { ns: 'common' })}
          </Button>
      )}
      />
      {children}
    </>
  );
};

export {
  BaseMobileStepper,
};
